import entities from './entities.js';

export default [...entities];
